import { put } from 'redux-saga/effects'

import countries from '../Fixtures/countries.json'
import CountryActions from '../Redux/CountryRedux'

export function* getCountries() {
    yield put(CountryActions.getCountriesSuccess(countries))
}
